import React from 'react';
import PropTypes from 'prop-types';
import {colors} from './../../assets/theme';
import ItemSmallLogo from './ItemSmallLogo';

class CharityHeader extends React.Component {   

    constructor(props){
        super(props);
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){
        return (
            <div className="CharityHeader">
                <div>
                    <ItemSmallLogo style={{width:100,height:100}} src={this.props.logo} />
                </div>
                    
                    <div>
                        <p className="charityName"> {this.props.name}</p>
                        <p className="introduction">{this.props.introduction}</p>
                    </div>

                <style jsx>{`
                    .CharityHeader {
                        display:flex;
                        padding-bottom:10px;
                        align-items: center;
                    }
                    
                    .charityName {
                        font-size:18px;
                        color: ${colors.primary};
                        font-weight:700;
                        margin-bottom:5px;
                    }

                    .introduction {
                        font-size:14px;
                        font-style: italic;
                        color:${colors.midGrey}
                    }


                `}</style>
            </div>
        )
    }
}

CharityHeader.propTypes = {
    logo : PropTypes.string,
    name : PropTypes.string,
    id : PropTypes.string,
    introduction : PropTypes.string
}

export default CharityHeader;



// WEBPACK FOOTER //
// ./src/components/common/CharityHeader.js